export enum ErrorEnum {
  ConnectionTimeout = 'Connection timeout. Check you internet connection.',
  ServerUnavailable = 'The server is temporarily unavailable.',
  NotFound = 'Bad request: Endpoint not found.',
  NotAuth = 'Error 401: You are not authorized.',
}
